import { IContactForList } from '@nkr/models/index';
import { Modal, Button, Alert, Table } from 'react-bootstrap';
import { ContactEntityType } from '@nkr/enums/index';

interface IProps {
    show: boolean,
    data: IContactForList,
    isCenter: boolean
    onDelete: () => void,
    onCancel: () => void
}

const Delete = (props: IProps) => {
    const renderContactName = () => {
        if (props.isCenter) {
            return <strong>{props.data.firstName} {props.data.lastName}</strong>;
        }

        switch (props.data.entityType) {
            case ContactEntityType.Other:
            case ContactEntityType.Vendor:
            case ContactEntityType.Donor:
            case ContactEntityType.Nkr:
            case ContactEntityType.Opo:
                return (
                    <Table bordered condensed>
                        <tbody>
                            <tr>
                                <td style={{ width: '20%', fontWeight: 550 }}>Type:</td>
                                <td>{props.data.entityTypeName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', fontWeight: 550 }}>Name:</td>
                                <td>{props.data.firstName} {props.data.lastName}</td>
                            </tr>
                        </tbody>
                    </Table>
                );

            case ContactEntityType.Center:
                return (
                    <Table bordered condensed>
                        <tbody>
                            <tr>
                                <td style={{ width: '20%', textAlign: 'right', fontWeight: 550 }}>Type:</td>
                                <td>{props.data.entityTypeName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', textAlign: 'right', fontWeight: 550 }}>Name:</td>
                                <td>{props.data.firstName} {props.data.lastName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', textAlign: 'right', fontWeight: 550 }}>Center:</td>
                                <td>{props.data.entityName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', textAlign: 'right', fontWeight: 550 }}>Positions:</td>
                                <td>
                                    {props.data.positions.map((position, index) =>
                                        <>
                                            {index > 0 && (<>, </>)}
                                            <span>{position.description}</span>
                                        </>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                );

            case ContactEntityType.SwapCourier:
                return (
                    <Table bordered condensed>
                        <tbody>
                            <tr>
                                <td style={{ width: '20%', fontWeight: 550 }}>Type:</td>
                                <td>{props.data.entityTypeName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', fontWeight: 550 }}>Name:</td>
                                <td>{props.data.firstName} {props.data.lastName}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '20%', fontWeight: 550 }}>Courier:</td>
                                <td>{props.data.entityName}</td>
                            </tr>
                        </tbody>
                    </Table>
                );
        }

        return null;
    }

    if (props.data == null)
        return null;

    return (
        <>
            <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Contact</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Alert bsStyle='danger' className='text-center' style={{ padding: '7.5px 15px 7.5px 15px' }}>
                        WARNING! Deleting a contact is irreversible!
                    </Alert>

                    <div className='text-center' style={{ marginBottom: 10 }}>Please confirm that you want to delete the following contact</div>

                    <div className='text-center'>
                        <div>{renderContactName()}</div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='danger' onClick={props.onDelete}>Yes, Delete</Button>
                    <Button onClick={props.onCancel}>No, Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Delete;